import * as PIXI from 'pixi.js';
import TextElement from "./TextElement";
import { CONSTANTS } from '../../PreviewDisplayConstants';
import { GetSpectrumMagnitude } from '../../ProcessSpectrum';

export default class TextContainer {
    constructor(stage, zIndex) {
        this.stage = stage;

        this.container = new PIXI.Container();
        this.container.zIndex = zIndex;

        this.textElements = [
            new TextElement(this.container),
            new TextElement(this.container),
            new TextElement(this.container),
            new TextElement(this.container),
            new TextElement(this.container),
            new TextElement(this.container),
            new TextElement(this.container),
        ];

        this.stage.addChild(this.container);
        this.container.position.set(CONSTANTS.DEFAULT_MID_X, CONSTANTS.DEFAULT_MID_Y);
    }

    update(config) {
        this.textElements.forEach((element, i) => {
            if (i < config.textElements.length) {
                element.update(config.textElements[i], i);
            } else {
                element.update(null);
            }
        });

        this.container.sortChildren();
    }

    draw(bassData) {
        const bassSpectrumMagnitude = GetSpectrumMagnitude(bassData);
        this.textElements.forEach(element => element.applyDrift(bassSpectrumMagnitude));
    }

    updateStage(stage) {
        this.stage = stage;
        this.stage.addChild(this.container);
    }

    destroy() {
        this.container.destroy({ children: true });
    }
}